import { Link, useNavigate } from "react-router-dom";

export function PrivacyPolicy() {
    const navigate = useNavigate();
    return <div className="component-container container-big mb-4 text-justify">
        <div>
            <button className="btn back-button" onClick={() => navigate(-1)}>⬅️</button>
            <h1 className="text-center"><span>🔒</span> Política de privacidad <span className="d-none d-md-inline">🔒</span></h1>
        </div>
        <p><strong>Política de Privacidad de ALSE</strong></p>
        <p>En ALSE, respetamos tu privacidad y nos comprometemos a proteger los datos personales que compartes con nosotros. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos tu información. Al usar nuestra aplicación, aceptas los términos descritos en esta política.</p>
        <hr/>
        <h3>1. <strong>Información que recopilamos</strong></h3>
        <h4>1.1. <strong>Datos almacenados en tu navegador</strong></h4>
        <p>Recopilamos y almacenamos la siguiente información en tu dispositivo mediante local storage y cookies:</p>
        <p><strong>Local storage:</strong></p>
        <ul>
            <li><code>__st_clockSkewInMillis</code>: Usado para sincronización de tiempo entre el servidor y el cliente.</li>
            <li><code>accepted_cookies</code>: Usado para saber si ya has aceptado las cookies.</li>
        </ul>
        <p><strong>Cookies:</strong></p>
        <ul>
            <li><code>sAccessToken</code>: Token de acceso para autenticar tus sesiones.</li>
            <li><code>sFrontToken</code>: Token de referencia para gestionar tu acceso.</li>
            <li><code>sRefreshToken</code>: Token de actualización de acceso.</li>
            <li><code>st-last-access-token-update</code>: Marca temporal de la última actualización del token de acceso.</li>
        </ul>
        <h4>1.2. <strong>Datos almacenados en nuestra base de datos</strong></h4>
        <ul>
            <li>Lista de signos marcados como favoritos y la fecha en que fueron seleccionados.</li>
            <li>Historial de prácticas, incluyendo los signos practicados, las fechas y si fueron recordados correctamente.</li>
        </ul>
        <hr/>
        <h3>2. <strong>Cómo utilizamos tu información</strong></h3>
        <p>Usamos la información recopilada para los siguientes propósitos:</p>
        <ol>
            <li><strong>Mejorar la experiencia del usuario:</strong> Personalizamos la frecuencia con la que se muestran ciertos signos durante la práctica en función de tus respuestas.</li>
            <li><strong>Proporcionar funcionalidades clave:</strong> Permitir la búsqueda, clasificación y gestión de tus signos favoritos.</li>
            <li><strong>Estadísticas y motivación:</strong> Generar informes y mostrar logros para ayudarte a mantener una racha de práctica continua.</li>
            <li><strong>Seguridad y gestión de sesiones:</strong> Gestionar tus sesiones activas mediante tokens almacenados en cookies.</li>
        </ol>
        <hr/>
        <h3>3. <strong>Con quién compartimos tu información</strong></h3>
        <p>En ALSE, no compartimos, vendemos ni alquilamos tu información personal a terceros. Solo compartiremos tu información en los siguientes casos:</p>
        <ul>
            <li><strong>Cumplimiento legal:</strong> Cuando sea requerido por la ley o una orden judicial.</li>
            <li><strong>Seguridad:</strong> Para proteger los derechos, la propiedad o la seguridad de ALSE, sus usuarios o el público.</li>
        </ul>
        <hr/>
        <h3>4. <strong>Protección de tus datos</strong></h3>
        <p>Implementamos medidas de seguridad adecuadas para proteger tu información frente a accesos no autorizados, alteraciones, divulgaciones o destrucciones. Esto incluye:</p>
        <ul>
            <li>Uso de conexiones seguras (HTTPS).</li>
            <li>Encriptación de datos sensibles.</li>
            <li>Control de acceso estricto a nuestra base de datos.</li>
        </ul>
        <hr/>
        <h3>5. <strong>Tus derechos</strong></h3>
        <p>Como usuario de ALSE, tienes los siguientes derechos en relación con tus datos:</p>
        <ol>
            <li><strong>Acceso:</strong> Puedes solicitar una copia de los datos personales que tenemos sobre ti.</li>
            <li><strong>Rectificación:</strong> Puedes corregir cualquier dato inexacto o incompleto.</li>
            <li><strong>Eliminación:</strong> Puedes solicitar que eliminemos tus datos personales, salvo cuando tengamos la obligación legal de conservarlos.</li>
            <li><strong>Portabilidad:</strong> Puedes solicitar que transfiramos tus datos a otra entidad.</li>
            <li><strong>Restricción del tratamiento:</strong> Puedes oponerte a ciertos usos de tus datos.</li>
        </ol>
        <p>Para ejercer estos derechos, por favor contáctanos a <Link to="mailto:dpo@nairoeducacion.org" target="_blank" rel="noreferrer">dpo@nairoeducacion.org</Link>.</p>
        <hr/>
        <h3>6. <strong>Duración del almacenamiento de datos</strong></h3>
        <p>Conservaremos tu información mientras uses la aplicación o según sea necesario para cumplir con nuestros propósitos descritos en esta política. Los datos pueden ser eliminados o anonimizados a petición del usuario.</p>
        <hr/>
        <h3>7. <strong>Menores de edad</strong></h3>
        <p>ALSE no está diseñada ni dirigida a menores de edad. Si descubrimos que hemos recopilado datos personales de un menor sin el consentimiento adecuado, eliminaremos esa información de inmediato.</p>
        <hr/>
        <h3>8. <strong>Cambios en esta política de privacidad</strong></h3>
        <p>Nos reservamos el derecho de actualizar esta política en cualquier momento. Notificaremos cualquier cambio importante a través de la aplicación o por otros medios apropiados. Te recomendamos revisar esta política periódicamente para mantenerte informado.</p>
        <hr/>
        <h3>9. <strong>Contacto</strong></h3>
        <p>Si tienes preguntas o inquietudes sobre esta política de privacidad, puedes contactarnos en <Link to="mailto:dpo@nairoeducacion.org" target="_blank" rel="noreferrer">dpo@nairoeducacion.org</Link></p>
        <p>Gracias por confiar en ALSE.</p>
    </div>
}